const constants = {
  dateRegExp: /^(1[0-2]|0[1-9])\/([1-2][0-9]|3[0-1]|0[1-9])\/(19[0-9][0-9]|20[0-9][0-9])$/,
  phoneRegExp: /^\d+$/,
  states: [
    'AL',
    'AK',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'MP',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY'
  ],
  schoolRoutes: [
    { name: 'Dashboard', route: '/dashboard' },
    { name: 'Issue Credential', route: '/dashboard/credForm' },
    { name: 'About', route: '/about' },
    { name: 'Contact', route: '/contact' }
  ],
  studentRoutes: [
    { name: 'Dashboard', route: '/dashboard' },
    { name: 'Settings', route: '/settings' },
    { name: 'About', route: '/about' },
    { name: 'Contact', route: '/contact' }
  ],
  VALIDATION_MSG: {
    DATE: 'Please provide a valid date.',
    EMAIL: 'Please enter a valid email.',
    REQUIRED: 'This is a required field.',
    URL: 'Please enter a valid URL.'
  }
};

export default constants;
